module.exports = __webpack_public_path__ + "img/vannkraft_med_paavirkningsgrad.735d6175.jpg";